import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as Constants from './device-detect.costants';
import { IDeviceInfo } from './device-info.interface';
import { DeviceBrowser } from './device-browser.enum';
import { ReTree } from './re-tree.class';

declare const InstallTrigger: any;

@Injectable()
export class DeviceDetectService {
    private _ua = '';
    private _pID = '';
    private _userAgent = '';
    private _os = '';
    private _browser = '';
    private _device = '';
    private _osVersion = '';
    private _browserVersion = '';

    constructor(@Inject(PLATFORM_ID) private platformId) {
        if (isPlatformBrowser(this.platformId)) {
            this._ua = window.navigator.userAgent;
            this._pID = platformId;
        }
        this._setDeviceInfo();
    }

    public getDeviceInfo(): IDeviceInfo {
        const deviceInfo: IDeviceInfo = {
            userAgent: this._userAgent,
            os: this._os,
            browser: this._browser,
            device: this._device,
            os_version: this._osVersion,
            browser_version: this._browserVersion,
            p_id: this._pID
        };
        return deviceInfo;
    }

    public isMobile(): boolean {
        return [
            Constants.DEVICES.ANDROID,
            Constants.DEVICES.IPHONE,
            Constants.DEVICES.I_POD,
            Constants.DEVICES.BLACKBERRY,
            Constants.DEVICES.FIREFOX_OS,
            Constants.DEVICES.WINDOWS_PHONE,
            Constants.DEVICES.VITA
        ].some(item => {
            return this._device === item;
        });
    }

    public isTablet() {
        return [Constants.DEVICES.I_PAD, Constants.DEVICES.FIREFOX_OS].some(item => {
            return this._device === item;
        });
    }

    public isDesktop() {
        return [Constants.DEVICES.PS4, Constants.DEVICES.CHROME_BOOK, Constants.DEVICES.UNKNOWN].some(item => {
            return this._device === item;
        });
    }

    public isBrowser(browser: DeviceBrowser): boolean {
        // Opera 8.0+
        const isOpera = (!!window['opr'] && !!window['opr'].addons) || !!window['opera'] || navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        const isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]"
        const isSafari =
            (p => {
                return p.toString() === '[object SafariRemoteNotification]';
            })(!window['safari'] || (typeof window['safari'] !== 'undefined' && window['safari'].pushNotification));

        // Internet Explorer 6-11
        const isIE = /*@cc_on!@*/ false || !!document['documentMode'];

        // Edge 20+
        const isEdge = !isIE && !!window['StyleMedia'];

        // Chrome 1+
        const isChrome = !!window['chrome'] && !!window['chrome'].webstore;

        // Blink engine detection
        const isBlink = (isChrome || isOpera) && !!window['CSS'];

        switch (browser) {
            case DeviceBrowser.OPERA:
                return isOpera;
            case DeviceBrowser.FIREFOX:
                return isFirefox;
            case DeviceBrowser.SAFARI:
                return isSafari;
            case DeviceBrowser.IE:
                return isIE;
            case DeviceBrowser.EDGE:
                return isEdge;
            case DeviceBrowser.CHROME:
                return isChrome;
            case DeviceBrowser.BLINK:
                return isBlink;
            default:
                return false;
        }
    }

    private _setDeviceInfo() {
        const reTree = new ReTree();
        const ua = this._ua;
        this._userAgent = ua;
        const mappings = [
            { const: 'OS', prop: '_os' },
            { const: 'BROWSERS', prop: '_browser' },
            { const: 'DEVICES', prop: '_device' },
            { const: 'OS_VERSIONS', prop: '_osVersion' }
        ];

        mappings.forEach(mapping => {
            this[mapping.prop] = Object.keys(Constants[mapping.const]).reduce((obj: any, item: any) => {
                obj[Constants[mapping.const][item]] = reTree.test(ua, Constants[`${mapping.const}_RE`][item]);
                return obj;
            }, {});
        });

        mappings.forEach(mapping => {
            this[mapping.prop] = Object.keys(Constants[mapping.const])
                .map(key => {
                    return Constants[mapping.const][key];
                })
                .reduce((previousValue, currentValue) => {
                    return previousValue === Constants[mapping.const].UNKNOWN && this[mapping.prop][currentValue]
                        ? currentValue
                        : previousValue;
                }, Constants[mapping.const].UNKNOWN);
        });

        this._browserVersion = '0';
        if (this._browser !== Constants.BROWSERS.UNKNOWN) {
            const re = Constants.BROWSER_VERSIONS_RE[this._browser];
            const res = reTree.exec(ua, re);
            if (!!res) {
                this._browserVersion = res[1];
            }
        }
    }
}
